module.exports = __webpack_public_path__ + "img/poster_1.00e9fe4f.png";